import { action } from 'typesafe-actions';
import { HistoryActionTypes } from './types';

export const createUpdateHistoryFieldAction = (fieldName: string, value: any, documentBlacklist?: Array<string>) =>
  action(HistoryActionTypes.UPDATE_HISTORY_FIELD, {
    fieldName,
    value,
    documentBlacklist,
  });
